var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 2.16667V4.66667C0.5 5.125 0.875 5.5 1.33333 5.5C1.79167 5.5 2.16667 5.125 2.16667 4.66667V3C2.16667 2.54167 2.54167 2.16667 3 2.16667H4.66667C5.125 2.16667 5.5 1.79167 5.5 1.33333C5.5 0.875 5.125 0.5 4.66667 0.5H2.16667C1.25 0.5 0.5 1.25 0.5 2.16667ZM1.33333 10.5C0.875 10.5 0.5 10.875 0.5 11.3333V13.8333C0.5 14.75 1.25 15.5 2.16667 15.5H4.66667C5.125 15.5 5.5 15.125 5.5 14.6667C5.5 14.2083 5.125 13.8333 4.66667 13.8333H3C2.54167 13.8333 2.16667 13.4583 2.16667 13V11.3333C2.16667 10.875 1.79167 10.5 1.33333 10.5ZM13.8333 13C13.8333 13.4583 13.4583 13.8333 13 13.8333H11.3333C10.875 13.8333 10.5 14.2083 10.5 14.6667C10.5 15.125 10.875 15.5 11.3333 15.5H13.8333C14.75 15.5 15.5 14.75 15.5 13.8333V11.3333C15.5 10.875 15.125 10.5 14.6667 10.5C14.2083 10.5 13.8333 10.875 13.8333 11.3333V13ZM13.8333 0.5H11.3333C10.875 0.5 10.5 0.875 10.5 1.33333C10.5 1.79167 10.875 2.16667 11.3333 2.16667H13C13.4583 2.16667 13.8333 2.54167 13.8333 3V4.66667C13.8333 5.125 14.2083 5.5 14.6667 5.5C15.125 5.5 15.5 5.125 15.5 4.66667V2.16667C15.5 1.25 14.75 0.5 13.8333 0.5Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreen);
export default __webpack_public_path__ + "static/media/full-screen.83922282ab9b84020866468ea7986729.svg";
export { ForwardRef as ReactComponent };